module.exports = __webpack_public_path__ + "static/img/application1-2.7db92e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application1-2.jpg
// module id = yU/M
// module chunks = 0